<script>
  import { _ } from 'svelte-i18n'
  import { modals, user } from '../../stores'
  import Modal from '../../elements/Modal.svelte'
  import TimesButton from '../../elements/TimesButton.svelte'
  import OpenBuyModalButton from '../OpenBuyModalButton.svelte'

  const modal_id = 'features'

  let expired = false

  $: if ($user) {
    expired = $user.expired
  }

</script>

<Modal large id={modal_id} preview_is_content={true}>
  <span slot="header">
    <TimesButton on:click={() => { modals.close() }}/>
  </span>
  
  <span slot="content">
    <div class="scrollable-content">
      <div class="title">
        <h3>Stop struggling with dropdown menus and discover</h3>
        <h1>An efficient and enjoyable way to choose fonts</h1>
        <video class="video" autoplay muted loop>
          <source src="/assets/videos/select-filter-compare.webm" type="video/webm">
          <!-- You can add additional source elements for different video formats here -->
        </video>
        <p>Wordmark displays your text with all your fonts, helping you to select, compare, and finally choose the best one for your needs</p>
      </div>
      <div class="mid-title">
        <h3>Frequently working with fonts?</h3>
        <h1>You'll love the additional &ldquo;Pro&rdquo; features</h1>
        <p>96% of our customers are saying they would be dissapointed without them<br> Now that is something special!</p>
      </div>
      <ul class="features">
        <li>
          <img src="/assets/images/organize.png" width="320" height="160" alt="Tag and categorize your fonts">
          <h3>Organize Your Fonts</h3>
          {$_('modals.features.tagging')}
        </li>
        <li>
          <img src="/assets/images/export-image.png" width="320" height="160" alt="Export as transparent png">
          <h3>Export As Image</h3>
          {$_('modals.features.export')}
        </li>
        <li>
          <img src="/assets/images/print.png" width="320" height="160" alt="Print fonts neatly arranged in a grid">
          <h3>Print Font Grids</h3>
          {$_('modals.features.print')}
        </li>
      </ul>
      <ul class="features">
        <li>
          <img src="/assets/images/character-map.png" width="320" height="160" alt="See and use all alternative characters">
          <h3>Font Character Map</h3>
          {$_('modals.features.characterMap')}
        </li>
        <li>
          <img src="/assets/images/auto-scroll.png" width="320" height="160" alt="Let the computer scroll the options">
          <h3>Autoscroll</h3>
          {$_('modals.features.autoscroll')}
        </li>
        <li>
          <img src="/assets/images/google-fonts.png" width="320" height="160" alt="Pick from thousands of Google Fonts">
          <h3>Use Google Fonts</h3>
          {$_('modals.features.google')}
        </li>
      </ul>
      <blockquote>This is the greatest Font app EVER!! I can't believe the time I have wasted going through fonts, choosing them, only to find they look horrible for the project I've been working on. With Wordmark it's so simple. There's no going back and forth.<br><b>&mdash;Buckeye Magic</b></blockquote>
      <ul class="features">
        <li>
          <img src="/assets/images/save-selections.png" width="320" height="160" alt="Save your selections">
          <h3>Save Your Selection</h3>
          {$_('modals.features.saveSelection')}
        </li>
        <li>
          <img src="/assets/images/sorting.png" width="320" height="160" alt="Sort fonts in reverse or random order">
          <h3>Alternative Sorting</h3>
          {$_('modals.features.sorting')}
        </li>
        <li>
          <img src="/assets/images/character-spacing.png" width="320" height="160" alt="Adjust spacing between the letters">
          <h3>Letter Spacing</h3>
          {$_('modals.features.tracking')}
        </li>
      </ul>
      <ul class="features">
        <li>
          <img src="/assets/images/search.png" width="320" height="160" alt="Search Font Names">
          <h3>Search Font Names</h3>
          {$_('modals.features.search')}
        </li>
        <li>
          <img src="/assets/images/character-highlighting.png" width="320" height="160" alt="Highlight selected characters">
          <h3>Character Highlighting</h3>
          {$_('modals.features.highlight')}
        </li>
        <li>
          <img src="/assets/images/night-theme.png" width="320" height="160" alt="Night Theme">
          <h3>Night Theme</h3>
          {$_('modals.features.theme')}
        </li>
      </ul>
      <blockquote>Great, works great and is simple to use. With over 3000 fonts on my computer this really helps make it less painful to choose a good font for a project. It also works amazing with Cricut Design Space.<br><b>&mdash;Caroline Searle</b></blockquote>
      <OpenBuyModalButton feature="features_page">See price and details</OpenBuyModalButton>
    </div>
  </span>  

</Modal>

<style>
  .scrollable-content {
    height: calc(100vh - 4rem);
    margin: -6rem -3rem -3rem;
    padding: 6rem;
    overflow-y: scroll;
  }
  .title {
    position: relative;
    margin-bottom: 8rem;
    text-align: center;
  }
  .title h1 {
    font-family: var(--PensumDisplay);
    font-size: 3.8rem;
    color: var(--c-accent);
  }
  .title h3 {
    font-size: 3.15rem;
    color: var(--c-text-big);
    margin-bottom: 2.6rem;
  }
  .title p {
    width: 60%;
    margin: 0 auto;
    font-family: var(--PensumSans-Bold);
    color: var(--c-text-faded);
    position: relative;
    z-index: 1;
  }

  .mid-title {
    margin-bottom: 6rem;
    text-align: center;
  }
  .mid-title h1 {
    font-family: var(--PensumDisplay);
    font-size: 3.2rem;
    color: var(--c-accent);
    display: inline-block;
    list-style: 2rem;
  }
  .mid-title h3 {
    font-size: 2.7rem;
    color: var(--c-text-big);
    margin-bottom: 1.8rem;
  }
  .mid-title p {
    margin: 1rem auto;
    text-decoration: underline;
    text-decoration-color: gold;
    text-decoration-skip-ink: none;
    text-decoration-thickness: 0.5em;
    text-underline-offset: -0.4rem;
  }

  ul.features {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 3rem;
  }
  ul.features li {
    position: relative;
    padding-bottom: 3rem;
    font-size: 1.4rem;
    line-height: 1.75rem;
    font-variant-numeric: lining-nums;
  }
  ul.features li:hover {
    position: relative;
    z-index: 1;
  }

  ul.features li h3 {
    margin-bottom: 0.5rem;
    color: var(--c-accent-orange);
  }

  ul.features {
    margin-top: 3rem;
  }



  img {
    width: 100%;
    margin-bottom: 0.5rem;
  }
  
  video {
    width: 60%;
    margin: 6rem auto 1.5rem;
    border-top-width: 1.6rem;
    box-shadow: var(--box-shadow);
    position: relative;
    z-index: 1;
  }

  img, video {
    border: 1px solid var(--c-button-ol);
    border-top-width: 1rem;
    border-top-right-radius: 0.4rem;
    border-top-left-radius: 0.4rem;
    border-bottom-left-radius: 0.2rem;
    border-bottom-right-radius: 0.2rem;
    transition: transform var(--transition-props);
  }

  img:hover, video:hover {
    transform: scale(1.33);
    transform-origin: center;
  }

  blockquote {
    background-color: #f9eca9;
    margin: 1rem 6rem 4rem;
    padding: 2rem 5rem 2rem;
    border-radius: 2rem;
    position: relative;
    font-size: 1.8rem;
    line-height: 2.5rem;
  }
  blockquote:before {
    content: "★★★★★";
    position: absolute;
    bottom: -0.6rem;
    left: 4rem;
    color: gold;
    letter-spacing: -2px;
    font-size: 1.4em;
    text-shadow: 1px 1px hsl(51 100% 47% / 1), -1px -1px hsl(51 100% 87% / 1);
  }
  blockquote:after {
    content: " ";
    position: absolute;
    bottom: -1.5rem;
    left: 1.5rem;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 1.5rem 2rem 0 0;
    border-color: #f9eca9 transparent transparent transparent;

  }

  .title::after {
    content: '';
    position: absolute;
    left: 9.5%;
    top: 31%;
    width: 0;
    height: 0;
    border: 34rem solid transparent;
    border-top: 35rem solid gold;
    z-index: 0;
    opacity: 0.5;
  }

  .scrollable-content :global(button) {
    display: block;
    margin: auto;
  }
</style>